import { useMemo } from 'react';

import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';
import { useGetCustomFieldColors } from '~/swr-hooks/customFields/useGetCustomFieldColors';
import { GeneralLibrary } from '~/utils/librariesUtils';
import { mapCustomFieldColorToPickerColor } from '~/utils/mapCustomFieldColorToPickerColor';

const DEFAULT_COLOR_NAME = 'Grey';
const DEFAULT_COLOR_FALLBACK = {
  backgroundHex: '#dcdcdc',
  fontHex: '#333333',
  name: 'Grey',
  id: 'grey',
};

export const useGeneralLibraryMetadata = () => {
  const { currentWorkspace } = useCurrentWorkspace();
  const { data: colors } = useGetCustomFieldColors();

  const generalLibraryTitle = currentWorkspace?.defaultLibrary ?? GeneralLibrary.title;
  const generalLibraryIcon = currentWorkspace?.defaultLibraryIcon ?? '🏠';
  const generalLibraryColorId = currentWorkspace?.defaultLibraryColorId;
  const generalLibraryDescription = currentWorkspace?.defaultLibraryDescription ?? '';

  const generalLibraryColor = useMemo(() => {
    const getColor = () => {
      const color = colors?.data?.find((color) => color.id === generalLibraryColorId);
      if (color) {
        return color;
      }

      const defaultColor = colors?.data?.find((color) => color.name === DEFAULT_COLOR_NAME);
      if (defaultColor) {
        return defaultColor;
      }

      return DEFAULT_COLOR_FALLBACK;
    };

    return mapCustomFieldColorToPickerColor(getColor());
  }, [colors, generalLibraryColorId]);

  return {
    generalLibraryTitle,
    generalLibraryIcon,
    generalLibraryColor,
    generalLibraryDescription,
  };
};
